export interface Comment {
  workItemId: number;
  id: number;
  version: number;
  text: string;
  createdBy: {
    displayName: string;
    url: string;
    _links: {
      avatar: {
        href: string;
      };
    };
    id: string;
    uniqueName: string;
    imageUrl: string;
    descriptor: string;
  };
  createdDate: Date;
  modifiedDate: Date;
  url: string;
}
